import { ReactElement } from 'react'
import { TestFooterWrapper } from './subcomponents'
import Button from 'react-bootstrap/Button'
import strings from '../../../locale/en'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../redux/store'

interface TestFooterProps {
  onPrevious: () => void
  onNext: () => void
  onReview: () => void
  onSubmit: () => void
}

const TestFooter = ({
  onPrevious,
  onNext,
  onReview,
  onSubmit
}: TestFooterProps): ReactElement => {
  const { isSubmitting } = useSelector(
    (state: RootState) => ({
      isSubmitting: state.test?.isSubmitting
    }),
    shallowEqual
  )
  const {
    test: { previous, markReview, next, submit }
  } = strings
  return (
    <TestFooterWrapper>
      <Button
        variant="outline-secondary"
        size="lg"
        onClick={onPrevious}
        disabled={isSubmitting}
      >
        {previous}
      </Button>
      <Button
        variant="warning"
        size="lg"
        onClick={onReview}
        disabled={isSubmitting}
      >
        {markReview}
      </Button>
      <Button
        variant="outline-secondary"
        size="lg"
        onClick={onNext}
        disabled={isSubmitting}
      >
        {next}
      </Button>
      <Button
        variant="success"
        size="lg"
        onClick={onSubmit}
        disabled={isSubmitting}
      >
        {submit}
      </Button>
    </TestFooterWrapper>
  )
}

export default TestFooter
